import {configureAppInfo} from '@smartmixin/core';

/**
 * The commit this bundle was built from (`CI_COMMIT_SHORT_SHA`, set in every
 * GitLab job, exposed by vite.config.ts), or `dev` locally.
 */
export const webappBuild = (): string =>
  import.meta.env.VITE_APP_BUILD || 'dev';

/**
 * Tell core which build this is, so every API call carries
 * X-SmartMixin-Platform: web and X-SmartMixin-BuildNumber (#379). No version:
 * the webapp has no store version and every load is the latest one.
 */
export const configureAppIdentity = () => {
  configureAppInfo({platform: 'web', build: webappBuild()});
};
